import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { TMaterialStyles } from '../../../theme';
import { Grid2 } from '@mui/material';
import { useGameStore } from '../../../stores';
import React, { useCallback } from 'react';
import { getTrainingModeData } from '../../../queries';
import { ModalWrapper } from '../../Wrappers/ModalWrapper';
import { useTranslation } from 'react-i18next';
import { ButtonOutlined } from '../../Buttons/ButtonOutlined';
import { useNavigate } from 'react-router';
import TypographyWithShadow from '../../Typography/TypographyWithShadow';
import { ERoutes } from '../../../enums';

interface ITrainingModeResultModal {
  open: boolean;
  handleClose: (value: boolean) => void;
  setIsStreetView: (data: boolean) => void;
  setIsTimerDisabled: (value: boolean) => void;
}

const TrainingModeResultModal: React.FC<ITrainingModeResultModal> = ({
  open,
  handleClose,
  setIsStreetView,
  setIsTimerDisabled,
}) => {
  const distance = useGameStore((state) => state.trainingModeResult?.distance);

  const navigate = useNavigate();

  const handleFinish = useCallback(() => {
    handleClose(false);
    navigate(ERoutes.gameModes);
  }, [handleClose, navigate]);

  const handleTryAgain = useCallback(async () => {
    try {
      await getTrainingModeData();
      setIsStreetView(true);
      setIsTimerDisabled(false);
      handleClose(false);
    } catch (error) {
      console.error('Error while [handleTryAgain]', error);
    }
  }, [handleClose, setIsStreetView, setIsTimerDisabled]);

  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ModalWrapper backgroundIllustrationName="GameResultModal" hasLabel>
        <Box sx={materialStyles.container}>
          <TypographyWithShadow shadowType="DARK" sx={materialStyles.title}>
            {t('game.your_result')}
          </TypographyWithShadow>

          <Grid2 sx={materialStyles.distanceContainer}>
            <TypographyWithShadow shadowType="DARK" sx={materialStyles.text}>
              {t('game.distance_to_location')}
            </TypographyWithShadow>
            <TypographyWithShadow shadowType="DARK" sx={materialStyles.amount}>
              {distance}
            </TypographyWithShadow>
          </Grid2>

          <Box sx={materialStyles.buttonsWrapper}>
            <ButtonOutlined
              shadowType="DARK"
              onClick={handleTryAgain}
              fontSize={19}
              sx={materialStyles.button}
            >
              {t('game.play_again')}
            </ButtonOutlined>

            <ButtonOutlined
              shadowType="DARK"
              onClick={handleFinish}
              fontSize={19}
              sx={materialStyles.button}
            >
              {t('game.main_menu')}
            </ButtonOutlined>
          </Box>
        </Box>
      </ModalWrapper>
    </Modal>
  );
};

export default React.memo(TrainingModeResultModal);

const materialStyles: TMaterialStyles = {
  container: {
    p: '46px 20px 21px',
  },
  title: {
    fontFamily: 'Rubber Duck !important',
    fontSize: '30px',
    textAlign: 'center',
  },
  buttonsWrapper: {
    marginTop: 2,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    textAlign: 'center',
    fontWeight: '700',
    fontSize: '16px',
  },
  amount: {
    textAlign: 'center',
    fontWeight: '700',
    fontSize: '18px',
  },
  button: {
    width: '165px',
    height: '41px',
    '&:first-of-type': {
      mb: '15px',
    },
  },
  distanceContainer: {
    mb: '12px',
  },
};
